/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Divider, Grid, IconButton, LinearProgress, Tab, Tabs, Typography, useTheme } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { FilesTable, ToolsDamInformation } from '../../../components/custom';
import { ConfirmationDialog, CustomAlert, VMenu } from '../../../components/shared';
import { LayoutBase } from '../../../layouts';
import { FileServicesBack, IFileServices } from '../../../services/api/files/FileServicesBack';
import { Add, ArrowForward, Delete, Search } from '@mui/icons-material';
import { useAuthContext } from '../../../context';
import { RPSB, ReportsServicesRpsb } from '../../../services/api/reports/ReportsServicesRpsb';
import { formatDateWhitoutHour, formatDateWhitoutHourEUA } from '../../../services/helpers/helpers';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const Rpsb = () => {
  const url = useParams();
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();
  const { userData } = useAuthContext();

  const pagePermissionsString: string | undefined = useMemo(() => {
    return userData?.nivel_acesso?.revisao?.RPSB;
  }, [userData]);

  const [data, setData] = useState<RPSB[]>([]);
  const theme = useTheme();

  const [confirmDialog, setConfirmDialog] = useState<boolean>(false);
  const [deletUUID, setDeletUUID] = useState<string>('');

  const [loadin, setLoadin] = useState<boolean>(false);
  const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
    open: false,
    message: '',
    severity: 'success'
  });

  useEffect(() => {
    setLoadin(true);
    fetheData();
  }, []);

  const fetheData = () => {
    if (url && url.id) {
      ReportsServicesRpsb.getAll(url.id)
        .then((result) => {
          if (result instanceof Error) {
            console.log(result.message);
            setLoadin(false);
          } else {
            setData(result);
            setLoadin(false);
          }
        });
    }
    setLoadin(false);
  };

  function SelectDeleteRPB(uuid_rpsb: string) {
    setDeletUUID(uuid_rpsb);
    setConfirmDialog(prev => !prev);
  }

  async function deleteRPSB() {
    if (deletUUID != '') {
      try {
        const res = await ReportsServicesRpsb.deleteRPSB(deletUUID);
        if (res instanceof Error) {
          setAlertInfo({ open: true, message: 'Erro ao deletar relatório!', severity: 'warning' });
          setConfirmDialog(false);
        } else {
          setAlertInfo({ open: true, message: 'RPSB deletado!', severity: 'success' });
          fetheData();
          setConfirmDialog(false);
        }
      } catch (error) {
        setAlertInfo({ open: true, message: 'Erro ao deletar relatório!', severity: 'warning' });
        setConfirmDialog(false);
      }
    } else {
      setAlertInfo({ open: true, message: 'RPSB não definido para deletar!', severity: 'warning' });
      setConfirmDialog(false);
    }
  }

  return (
    <LayoutBase
      title='Revisão Periódica de Segurança de Barragens (RPSB)'
      tollBar={<ToolsDamInformation />}
    >
      <Box width={'100%'}>
        <VMenu id={url.id} />
        <Box sx={{ padding: 1, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <Box sx={{ width: '100%' }}>
            <Typography variant='h5' sx={{ marginTop: 1 }}>Revisão Periódica de Segurança de Barragens (RPSB)</Typography>
            <Divider />
          </Box>
          <Box>
            <Button disabled={!pagePermissionsString?.includes('add')} startIcon={<Add />} onClick={() => navigate('./new')} sx={{ padding: 2 }} >Novo</Button>
          </Box>
        </Box>
        {loadin && (
          <LinearProgress sx={{ padding: 2 }} />
        )}
        {!loadin && data.map((item, index) => (
          <Box key={index} sx={{ border: '1px #ccc solid', borderRadius: '25px', padding: 3, display: 'flex', flexDirection: 'row', margin: 2, justifyContent: 'space-between', }}>
            <Box>
              <Typography><strong>Data de criação:</strong>{formatDateWhitoutHour(item.data_criacao)}</Typography>
              <Typography><strong>Data de inspeção: </strong>{formatDateWhitoutHour(item.data_inspecao)}</Typography>
              <Typography><strong>Responsavel : </strong>{item.responsavel}</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <IconButton sx={{ color: theme.palette.primary.main }} onClick={() => navigate(`./${item.uuid}`)}><ArrowForward /></IconButton>
              <IconButton disabled={!pagePermissionsString?.includes('remove')} sx={{ color: theme.palette.error.main }} onClick={() => SelectDeleteRPB(item.uuid ?? '')}><Delete /></IconButton>
            </Box>
          </Box>
        ))}
      </Box>
      {alertInfo.open &&
        <CustomAlert
          message={alertInfo.message}
          severity={alertInfo.severity}
        />
      }
      <ConfirmationDialog
        isOpen={confirmDialog}
        onClose={() => setConfirmDialog(false)}
        onConfirm={deleteRPSB}
        title="Confirmar exclusão do RPSB"
        message="Tem certeza que deseja excluir esta relatório? Esta ação não pode ser desfeita."
      />
    </LayoutBase>
  );
};